/**
 * Redux ducks for phone installation state.
 * Shared across all React trees (modern.js and providerContainer).
 */
import { extractInstallationData } from 'admin/Integrations/modules/installationActions'

// Action types
const FETCH_START = 'phoneInstallation/FETCH_START'
const FETCH_SUCCESS = 'phoneInstallation/FETCH_SUCCESS'
const FETCH_ERROR = 'phoneInstallation/FETCH_ERROR'
const UPDATE_INSTALLATION = 'phoneInstallation/UPDATE_INSTALLATION'
const SET_PRE_INSTALL_MODAL = 'phoneInstallation/SET_PRE_INSTALL_MODAL'
const SET_INSTALLING = 'phoneInstallation/SET_INSTALLING'

// Initial state
export const initialState = {
  phoneIntegration: null,
  phoneInstallation: null,
  enabledUserIds: [],
  userHasProvisionedPhone: false,
  provisionedPhoneNumber: null,
  isLoaded: false,
  error: null,
  showPreInstallModal: false,
  isInstalling: false
}

// Reducer
export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_START:
      return {
        ...state,
        isLoaded: false,
        error: null
      }
    case FETCH_SUCCESS:
      return {
        ...state,
        phoneIntegration: action.payload.integration,
        phoneInstallation: action.payload.installation,
        enabledUserIds: action.payload.enabledUserIds || [],
        userHasProvisionedPhone: action.payload.hasProvisionedPhone || false,
        provisionedPhoneNumber: action.payload.provisionedPhoneNumber || null,
        error: action.payload.error,
        isLoaded: true
      }
    case FETCH_ERROR:
      return {
        ...state,
        error: action.payload,
        isLoaded: true
      }
    case UPDATE_INSTALLATION:
      return {
        ...state,
        phoneInstallation: action.payload.installation,
        enabledUserIds: action.payload.enabledUserIds ?? state.enabledUserIds,
        userHasProvisionedPhone: action.payload.hasProvisionedPhone ?? state.userHasProvisionedPhone,
        provisionedPhoneNumber: action.payload.provisionedPhoneNumber ?? state.provisionedPhoneNumber
      }
    case SET_PRE_INSTALL_MODAL:
      return {
        ...state,
        showPreInstallModal: action.payload
      }
    case SET_INSTALLING:
      return {
        ...state,
        isInstalling: action.payload
      }
    default:
      return state
  }
}

// Action creators (synchronous)
export const fetchStart = () => ({ type: FETCH_START })

export const fetchSuccess = (payload) => ({
  type: FETCH_SUCCESS,
  payload
})

export const fetchError = (error) => ({
  type: FETCH_ERROR,
  payload: error
})

export const updatePhoneInstallation = (installation, installationSettings, currentUserId) => {
  const extracted = extractInstallationData({
    integrationSettings: installation?.integration?.integration_settings,
    installationSettings,
    userId: currentUserId
  })

  return {
    type: UPDATE_INSTALLATION,
    payload: { installation, ...extracted }
  }
}

export const setPreInstallModal = (show) => ({
  type: SET_PRE_INSTALL_MODAL,
  payload: show
})

export const setInstalling = (installing) => ({
  type: SET_INSTALLING,
  payload: installing
})

// Selectors
export const selectPhoneInstallation = (state) => state.phoneInstallation || initialState
